import React from "react";
import { useTranslation } from "react-i18next";

interface PaymentResultModalProps {
  isOpen: boolean;
  onClose: () => void;
  isSuccess: boolean;
  message?: string;
}

const PaymentResultModal: React.FC<PaymentResultModalProps> = ({
  isOpen,
  onClose,
  isSuccess,
  message
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const defaultSuccessMessage = t("paymentModal.successMessage");
  const defaultErrorMessage = t("paymentModal.errorMessage");

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center">
      <div className="bg-gradient-to-b from-black/70 via-zinc-900/80 to-zinc-800/90 text-white p-8 rounded-2xl max-w-md w-full shadow-2xl relative border border-white/20">
        <button
          onClick={onClose}
                      className="absolute top-3 right-4 text-2xl hover:text-brand-red-text cursor-pointer"
        >
          ×
        </button>

        <div className="text-center py-6">
          <div className="text-6xl mb-4">
            {isSuccess ? "🎉" : "❌"}
          </div>
          
          <h2 className="text-2xl font-bold mb-4">
            {isSuccess ? t("paymentModal.successTitle") : t("paymentModal.errorTitle")}
          </h2>
          
          <p className="text-gray-300 mb-6">
            {message || (isSuccess ? defaultSuccessMessage : defaultErrorMessage)}
          </p>
          
          <button
            onClick={onClose}
            className="bg-[#D8001D] hover:bg-[#B8001A] text-white px-6 py-2 rounded font-semibold cursor-pointer"
          >
            {t("paymentModal.close")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentResultModal; 